import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=394aea7c&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=394aea7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394aea7c",
  null
  
)

export default component.exports